<app-anagrafica-parte-form
  [isParteForm]="true"
  (parteChange)="onEmitAnagrafica($event)"
  *ngIf="currentForm == form.ANAGRAFICA"></app-anagrafica-parte-form>
<app-associazione-controparte-form
[primariaPreselected] = "controparti.length === 0"
[parte]="parte"
(onReturn)="onEmitAssociativa($event)"
*ngIf="currentForm == form.ASSOCIATIVA"></app-associazione-controparte-form>
